// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".glass{position:absolute;margin-left:5px;height:24px;display:flex;align-items:center;z-index:1000;font-size:24px;color:#d0d0d0}.search-input{display:block;width:100%;padding-left:45px;height:calc(2.25rem + 2px);font-size:1rem;line-height:1.5;color:#4582c0;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;outline:0;border-width:0 0 2px;margin-top:30px;margin-bottom:20px}.search-input:focus{border-color:silver}.search-group{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
